import "./contact.css";

export const Contact = () => {
  return (
    <>
      <section class="contact-section">
        <h2>Connect With Us Today</h2>
        <div class="contact-content">
          <p>Welcome to Vaidika Vignanam Samvardhini</p>
          <p>
            We are honored to guide you on your sacred journey. Whether you are
            looking for personalized rituals, pujas, or expert advice, we are
            here to help. Reach out to us, and let us create divine experiences
            tailored to your spiritual needs.
          </p>
          <h3>Reach Out To Us</h3>

          <p>
            <strong>Phone:</strong>
            +919540205885
          </p>
          <p>
            <strong>Email:</strong> ramstartwork@gmail.com
          </p>
          <p>
            <strong>Address:</strong> No # 34, 7th Cross, 3rd Cross, Teachers
            Layout, 2nd Stage M S Palya, Vidyaranyapura, Bangalore-560097
          </p>

          <h3>Connect with Us</h3>
          <form class="contact-form">
            <input type="text" placeholder="Full Name" required />
            <input type="email" placeholder="Email Address" required />
            <input type="tel" placeholder="Phone Number" required />
            <textarea
              placeholder="Message/Inquiry"
              rows="4"
              required
            ></textarea>
            <select>
              <option value="" selected disabled>
                Preferred Ritual/Service
              </option>
              <option value="Gruhapravesam">Gruhapravesam</option>
              <option value="Marriage">Marriage</option>
              <option value="Namakaranam">Namakaranam</option>
              <option value="Anna prashana">Anna Prashana</option>
              <option value="Nischitartham">Nischitartham</option>
              <option value="Ganapati Puja">Ganapati Puja</option>
              <option value="Lakshmi Puja">Lakshmi Puja</option>
              <option value="Ayudha Puja">Ayudha Puja</option>
              <option value="Rudra Puja">Rudra Puja</option>
              <option value="Satya Narayana Puja">Satya Narayana Puja</option>
              <option value="Punyaha Vachanam">Punyaha Vachanam</option>
              <option value="Ganapathi Homam">Ganapathi Homa</option>
              <option value=" Lakshmi Homa"> Lakshmi Homa</option>
              <option value="Chandi Homa">Chandi Homa</option>
              <option value="Pratyangira Homa">Pratyangira Homa</option>
              <option value="Lakshmi Ganapati Homa">
                Lakshmi Ganapati Homa
              </option>
              <option value="Ayushya Homa">Ayushya Homa</option>
              <option value="Vastu Shanti Homa">Vastu Shanti Homa</option>
              <option value="Mrutyunjaya Homa">Mrutyunjaya Homa</option>
              <option value="Dhanvantari Homa">Dhanvantari Homa</option>
              <option value="Sudarshana Homa">Sudarshana Homa</option>
              <option value="Shashtti Poorthi">Shashtti Poorthi</option>
              <option value="Navagraha Shanti">Navagraha Shanti</option>
              <option value="Bheema Ratha Shanthi">Bheema Ratha Shanthi</option>
              <option value="Sahasra Chandra Darshana Santhi">
                Sahasra Chandra Darshana Santhi
              </option>
              <option value="Nakshatra Shanti">Nakshatra Shanti</option>
            </select>
            <input type="text" placeholder="Best Time to Contact" required />
            <button type="submit">Submit Your Request</button>
          </form>
        </div>
      </section>
    </>
  );
};
